/* eslint-disable */
(async () => {
  function initStoriesLightbox() {
    MicroModal.init({
      openClass: 'is-open',
      awaitOpenAnimation: true,
      awaitCloseAnimation: true,
      disableScroll: true,
    });
  }

  function initStoriesAnimation() {
    const storiesHero = document.querySelector('.stories-hero');
    if (!storiesHero) return;
    const circleOutline = document.getElementById('hero-stories__circle-outline');
    const circleInner = document.getElementById('hero-stories__circle-inner');
    const circlePair = document.getElementById('hero-stories__circle-pair');
    const circlePath = document.querySelector('#hero-stories__circle-path path');
    const mm = gsap.matchMedia();
    const breakpoint = 1024;

    const tweenTl = gsap.timeline({
      animation: gsap,
      trigger: storiesHero,
      start: `top bottom`,
      end: `bottom +=200`,
      //onEnter, onLeave, onEnterBack, onLeaveBack
      toggleActions: 'play pause play pause',
    });

    function tweenProperty(target, prop, min, max) {
      const randomDur = gsap.utils.random(3, 6, 0.2, true);
      const randomDelay = gsap.utils.random(0.6, 2, 0.2, true);
      let randomVal = gsap.utils.random(min, max);

      tweenTl.to(target, {
          [prop]: randomVal,
          duration: randomDur(), 
          delay: randomDelay(), 
          ease: 'none',
          onComplete: tweenProperty,
          onCompleteParams: [target, prop, min, max]
        });
    }

    function heroOutline() {
      const outlineOrbitTl = gsap.timeline({
        paused: true,
        scrollTrigger: {
          trigger: storiesHero,
          start: `top bottom`,
          end: `bottom +=200`,
          //onEnter, onLeave, onEnterBack, onLeaveBack
          toggleActions: "play pause play pause",
          // markers: true,
        },
        defaults: {
          ease: 'sine.inOut',
          duration: 90,
        },
        repeat: -1,
      })
        .to(circleOutline, {
          motionPath: {
            path: circlePath,
            align: circlePath,
            alignOrigin: [0.5, 0.5],
          },
        });
      tweenProperty('.circle-outline', 'scale', 0.65, 1);
    }

    function heroPair() {
      const pairOrbitTl = gsap.timeline({
        scrollTrigger: {
          trigger: storiesHero,
          start: `top bottom`,
          end: `bottom +=200`,
          //onEnter, onLeave, onEnterBack, onLeaveBack
          toggleActions: 'play pause play pause',
          // markers: true,
        },
        defaults: {
          ease: 'sine.inOut',
          duration: 120,
        },
        repeat: -1,
        paused: true,
      })
        .to(circlePair, {
          reversed: true,
          motionPath: {
            path: circlePath,
            align: circlePath,
            alignOrigin: [0.5, 0.5],
          },
        });

      gsap.utils.toArray('.circle-pair').forEach(circle => {
        tweenProperty(circle, 'scale', 0.65, 1);
      });
    }

    mm.add({
      isDesktop: `(min-width: ${breakpoint}px)`,
      isMobile: `(max-width: ${breakpoint - 1}px)`,
      reduceMotion: '(prefers-reduced-motion: reduce)',
    }, (context) => {
      const { isDesktop, reduceMotion } = context.conditions;
      if (!reduceMotion) {
        heroOutline();
        heroPair();
        tweenProperty(circleInner, 'xPercent', -180, 85);
        tweenProperty(circleInner, 'yPercent', -180, 50);
      }
    });
  }

  async function handleLoadMore() {
    const storiesMain = document.getElementById('stories-main');
    const storiesContainer = storiesMain.firstElementChild;
    const storyGrid = document.querySelector('.stories-grid');
    const storyTemplate = document.getElementById('story-card-template');
    const storiesLoader = document.getElementById('stories-loader');
    const storiesLoadMoreButton = document.getElementById('stories-load-more-button');

    const state = {
      page: 1,
      moreStories: true,
    };
    const loadingTl = gsap.timeline({
      paused: true,
    })
      .fromTo(storiesLoader, {
        display: 'none',
      }, {
        display: 'inline-flex',
        duration: 0.01,
      })
      .fromTo(storiesLoader, {
        opacity: '0',
      }, {
        opacity: '1',
        duration: 0.15,
      });

    async function init() {
      readURL();

      storiesLoadMoreButton.addEventListener('click', loadMoreStories);
      window.addEventListener('popstate', handleBackButton);

      const stories = await getStories(state.page);
      state.moreStories = stories.remaining;
      appendStories(stories.posts);
      initStoriesLightbox();
      updateLoadMoreButton();
    }
    await init();

    async function getStories(pages) {
      try {
        setLoading(true);
        const offset = pages ? 0 : (state.page - 1) * 9;
        const defaultedPages = pages || 1;
        const data = new FormData();
        data.append('action', 'get_stories');
        data.append('nonce', storiesAjax.posts_query_nonce);
        data.append('offset', offset);
        data.append('numberPosts', 9 * defaultedPages);
        const response = await fetch(storiesAjax.ajax_url, {
          method: 'POST',
          credentials: 'same-origin',
          body: data,
        });
  
        if (response.ok === false) {
          throw new Error('filter insights failed');
        }
  
        const stories = await response.json();
  
        setTimeout(setLoadingFalse, 150);
  
        return stories;
      } catch (e) {
        // console.log(e);
        return null;
      }
    }

    function handleBackButton() {
      window.location.reload();
    }

    function appendStories(stories, event) {
      stories.forEach((story, index) => {
        const uniqueId = Math.floor(Math.random(index) * Date.now()).toString(32);
        const modalId = `modal-${uniqueId}`;
        const cardElement = createStoryElement(story, modalId);
        storyGrid.appendChild(cardElement);

        if (index === 0 && event) {
          function focusFirstEl() {
            const firstEl = document.querySelector(`[data-micromodal-trigger='${modalId}']`);
            firstEl.scrollIntoView();
            firstEl.focus();
          }
          setTimeout(focusFirstEl, 100);
        }
      });
    }

    function createStoryElement(story, modalId) {
      const storyClone = storyTemplate.content.cloneNode(true);
      storyClone.querySelector('.story-card').classList.add(`card-${story.idx}`);

      const name = storyClone.querySelector('.story-card-name');
      const location = storyClone.querySelector('.story-card-location');
      const excerpt = storyClone.querySelector('.story-card-excerpt');
      const button = storyClone.querySelector('.story-card-button');
      const modal = storyClone.querySelector('.modal');
      const modalDialog = storyClone.querySelector('.modal-dialog');
      const modalTitle = storyClone.querySelector('.modal-title');
      const modalName = storyClone.querySelector('.modal-name');
      const modalKicker = storyClone.querySelector('.modal-kicker');
      const modalContent = storyClone.querySelector('.modal-content');      
  
      modal.id = modalId;
      modalDialog.setAttribute('aria-labelledby', `${modalId}-title`);
      button.setAttribute('data-micromodal-trigger', modalId);
      modalTitle.parentElement.id = `${modalId}-content`;
      modalTitle.id = `${modalId}-title`;
  
      name.innerHTML = story.name;
      modalName.innerHTML = story.name;
      location.innerHTML = story.location;
      excerpt.innerHTML = story.excerpt;
      modalContent.innerHTML = story.content;
      modalKicker.innerHTML = story.location ? `A Personal Story From ${story.location}` : 'A Personal Story';
  
      return storyClone;
    }
  
    function setLoading(isLoading = true) {

      if (isLoading) {
        loadingTl.play();
      } else {
        loadingTl.reverse();
      }
    }
  
    function setLoadingFalse() {
      setLoading(false);
    }

    function updateLoadMoreButton() {
      const loadMoreContainer = document.querySelector('.stories-load-more');
      if (state.moreStories) {
        loadMoreContainer.classList.add('button-visible');
      } else {
        loadMoreContainer.classList.remove('button-visible');
      }
    }
  
    async function loadMoreStories(event) {
      state.page += 1;      
      const stories = await getStories();
      state.moreStories = stories.remaining;
      appendStories(stories.posts, event);
      initStoriesLightbox();
      updateLoadMoreButton();
      updateURL();
    }
  
    function readURL() {
      const url = new URL(window.location);  

      const page = url.searchParams.get('pg');
  
      if (page) {
        const typedPage = +page;
        if (!Number.isNaN(typedPage)) {
          state.page = typedPage;
        }
      }
    }
  
    function updateURL() {
      const url = new URL(window.location);
  
      if (state.page > 1) {
        url.searchParams.set('pg', state.page);
      } else {
        url.searchParams.delete('pg');
      }
  
      window.history.pushState({}, '', url);
    }
  }

  function init(){
    initStoriesAnimation();
    handleLoadMore();
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
